import type { RouteObject } from 'react-router-dom'
import { lazy, Suspense } from 'react'
import Home from '@/pages/Home'
import { useRoutes } from 'react-router-dom'

/* ── Training Hub Pages ── */
const CalculatorPage       = lazy(() => import('@/pages/Calculator'))
const LeanPhysiquePage     = lazy(() => import('@/pages/LeanPhysique'))
const WomensStrengthPage   = lazy(() => import('@/pages/WomensStrength'))
const HardgainersPage      = lazy(() => import('@/pages/Hardgainers'))

/* ── Articles Listing ── */
const ArticlesPage         = lazy(() => import('@/pages/Articles'))

/* ── Individual Article Pages ── */
const LegWorkoutForMass       = lazy(() => import('@/pages/articles/LegWorkoutForMass'))
const TenLbMuscleGain         = lazy(() => import('@/pages/articles/TenLbMuscleGain'))
const BodyweightMuscleGain    = lazy(() => import('@/pages/articles/BodyweightMuscleGain'))
const LeanMuscleDefinition    = lazy(() => import('@/pages/articles/LeanMuscleDefinition'))
const NutritionMuscleBuilding = lazy(() => import('@/pages/articles/NutritionMuscleBuilding'))
const LeanBulkingMen          = lazy(() => import('@/pages/articles/LeanBulkingMen'))
const WomenStrengthTraining   = lazy(() => import('@/pages/articles/WomenStrengthTraining'))
const ProgressiveOverloadGuide = lazy(() => import('@/pages/articles/ProgressiveOverloadGuide'))

const LazyFallback = <div className="min-h-screen bg-[#0F0F1A]" />

/* ── Route Definitions — exported for prerender.tsx ── */
export const routes: RouteObject[] = [
  /* Core pages */
  { path: '/', element: <Home /> },
  {
    path: '/calculator',
    element: <Suspense fallback={LazyFallback}><CalculatorPage /></Suspense>,
  },

  /* Training Hubs */
  {
    path: '/lean-physique',
    element: <Suspense fallback={LazyFallback}><LeanPhysiquePage /></Suspense>,
  },
  {
    path: '/womens-strength',
    element: <Suspense fallback={LazyFallback}><WomensStrengthPage /></Suspense>,
  },
  {
    path: '/hardgainers',
    element: <Suspense fallback={LazyFallback}><HardgainersPage /></Suspense>,
  },

  /* Articles Listing */
  {
    path: '/articles',
    element: <Suspense fallback={LazyFallback}><ArticlesPage /></Suspense>,
  },

  /* Individual Article Detail Pages */
  {
    path: '/articles/leg-workout-for-mass',
    element: <Suspense fallback={LazyFallback}><LegWorkoutForMass /></Suspense>,
  },
  {
    path: '/articles/10lb-muscle-gain-12-weeks',
    element: <Suspense fallback={LazyFallback}><TenLbMuscleGain /></Suspense>,
  },
  {
    path: '/articles/bodyweight-muscle-gain',
    element: <Suspense fallback={LazyFallback}><BodyweightMuscleGain /></Suspense>,
  },
  {
    path: '/articles/lean-muscle-definition',
    element: <Suspense fallback={LazyFallback}><LeanMuscleDefinition /></Suspense>,
  },
  {
    path: '/articles/nutrition-muscle-building',
    element: <Suspense fallback={LazyFallback}><NutritionMuscleBuilding /></Suspense>,
  },
  {
    path: '/articles/lean-bulking-men',
    element: <Suspense fallback={LazyFallback}><LeanBulkingMen /></Suspense>,
  },
  {
    path: '/articles/women-strength-training',
    element: <Suspense fallback={LazyFallback}><WomenStrengthTraining /></Suspense>,
  },
  {
    path: '/articles/progressive-overload-guide',
    element: <Suspense fallback={LazyFallback}><ProgressiveOverloadGuide /></Suspense>,
  },
]

function App() {
  return useRoutes(routes)
}

export default App
